import { render, staticRenderFns } from "./policeLevel.vue?vue&type=template&id=55931d9e&scoped=true&"
import script from "./policeLevel.vue?vue&type=script&lang=js&"
export * from "./policeLevel.vue?vue&type=script&lang=js&"
import style0 from "./policeLevel.vue?vue&type=style&index=0&id=55931d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55931d9e",
  null
  
)

export default component.exports